(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const isDesktop = window.matchMedia('(min-width: 990px)').matches;
  const threshold = isDesktop ? 0.75 : 0.5;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('section-footer--reveal');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: threshold,
    }
  );

  observer.observe(document.querySelector('.section-footer'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-intro"] && !Shopify.designMode) return;
  try {
    
  class HeroIntro extends HTMLElement {
    connectedCallback() {
      const mediaContainer = this.querySelector('[data-intro-media-container]');
      const content = this.querySelector('[data-intro-content]');

      const updateExpandedState = () => {
        const isExpanded = mediaContainer.getBoundingClientRect().top <= content.getBoundingClientRect().bottom;
        this.classList.toggle('hero-intro--expanded', isExpanded);
      };

      this.handleScroll = () => requestAnimationFrame(updateExpandedState);
      this.handleResize = () => this.style.setProperty('--hero-intro-content-height', `${content.offsetHeight}px`);

      this.handleResize();

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }
  }

  if (!customElements.get('hero-intro')) {
    customElements.define('hero-intro', HeroIntro);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insights-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Trigger animation for the media element
    const sections = document.querySelectorAll('.insights-intro-section');

    sections.forEach((section) => {
      const media = section.querySelector('.insights-intro-section__media');
      if (!media) return;

      // Set media as animated so it only runs once
      const triggerAnimation = () => {
        if (media.hasAttribute('data-animated')) return;

        media.setAttribute('data-animated', 'true');
        media.classList.add('fade-in');

        // Stop both observers once animated
        scrollObserver.disconnect();
        visibilityObserver.disconnect();
      };

      // Trigger when 50% of media is visible
      const visibilityObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) triggerAnimation();
          });
        },
        {
          rootMargin: '0px',
          threshold: 0.5,
        }
      );

      // Also trigger when user scrolls to top of media (fallback for short screens)
      const scrollObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) triggerAnimation();
          });
        },
        {
          rootMargin: '0px 0px -100% 0px',
          threshold: 0,
        }
      );

      // Observe both, whichever triggers first wins
      visibilityObserver.observe(media);
      scrollObserver.observe(media);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insights-related"] && !Shopify.designMode) return;
  try {
    
  const initInsightsAnimation = () => {
    const section = document.querySelector('.related-insights-section[data-animate-cards]');

    if (!section || window.innerWidth < 990) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    observer.observe(section);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInsightsAnimation);
  } else {
    initInsightsAnimation();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overview"] && !Shopify.designMode) return;
  try {
    
  class OverviewSection extends HTMLElement {
    /** @type {IntersectionObserver | null} */
    observer = null;

    /** @type {MediaQueryList} */
    mobileQuery = window.matchMedia('(max-width: 989px)');

    constructor() {
      super();
      this.titles = this.querySelectorAll('[data-overview-title]');
      this.descriptions = this.querySelectorAll('[data-overview-content]');
      this.contentContainer = this.querySelector('.overview-section__content');
      this.scrollParent = this.querySelector('.overview-section__scroll-container');
    }

    /**
     * Initializes the section when connected to the DOM
     */
    connectedCallback() {
      this.calculateAutoHeight();
      this.setupObserver();
      this.setupTitleClicks();

      this.mobileQuery.addEventListener('change', () => {
        this.observer?.disconnect();
        this.setupObserver();
      });
    }

    /**
     * Returns the scroll container based on viewport size
     * @returns {HTMLElement}
     */
    get scrollContainer() {
      return this.mobileQuery.matches && this.contentContainer ? this.contentContainer : this.scrollParent;
    }

    /**
     * Calculates and sets the max content height based on the tallest description
     * @private
     */
    calculateAutoHeight() {
      if (!this.hasAttribute('auto-height')) return;

      let maxHeight = 0;

      this.descriptions.forEach((description, index) => {
        maxHeight = Math.max(maxHeight, description.offsetHeight);

        if (index === this.descriptions.length - 1) {
          this.style.setProperty('--last-item-height', `${description.offsetHeight}px`);
        }
      });

      this.style.setProperty('--max-content-height', `${maxHeight}px`);
    }

    /**
     * Sets up intersection observer to track visible content sections
     * @private
     */
    setupObserver() {
      if (!this.descriptions.length) return;

      const root = this.scrollContainer;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            const index = entry.target.dataset.overviewContent;
            this.setActiveTitle(index);
          }
        },
        {
          root,
          rootMargin: '-40% 0px -40% 0px',
          threshold: 0,
        }
      );

      this.descriptions.forEach((description) => {
        this.observer.observe(description);
      });
    }

    /**
     * Updates active title based on visible content
     * @param {string} index - The content index that is visible
     * @private
     */
    setActiveTitle(index) {
      this.titles.forEach((title) => {
        title.classList.toggle('overview-section__title--active', title.dataset.overviewTitle === index);
      });
    }

    /**
     * Sets up click handlers on titles to scroll to corresponding content
     * @private
     */
    setupTitleClicks() {
      this.titles.forEach((title) => {
        title.addEventListener('click', () => {
          const index = title.dataset.overviewTitle;
          const description = this.querySelector(`[data-overview-content="${index}"]`);
          if (!description) return;

          const container = this.scrollContainer;
          const scrollPadding = parseInt(getComputedStyle(container).scrollPaddingTop) || 0;
          const targetPosition = description.offsetTop - scrollPadding;

          container.scrollTo({ top: targetPosition, behavior: 'smooth' });
        });
      });
    }

    /**
     * Cleans up resources when disconnected from the DOM
     */
    disconnectedCallback() {
      this.observer?.disconnect();

      this.mobileQuery.removeEventListener('change', this.setupObserver);
    }
  }

  if (!customElements.get('overview-section')) {
    customElements.define('overview-section', OverviewSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.partners-list-section');

    const selectors = {
      partnerListItems: '[data-partner-list-item]',
      partnerListLinks: '[data-partner-list-link]',
      partnerListImages: '[data-partner-image]',
      partnerListSectionTitle: '[data-partners-section-title]',
      partnerListHeader: '[data-partner-list-header]',
      partnerListImageContainer: '[data-partners-image-container]',
      partnerListImageInner: '[data-partners-image-inner]',
    };

    const classes = {
      partnerLinkActive: 'partners-list__item-link--active',
      partnerImageActive: 'partners-list-section__image-item--active',
    };

    sections.forEach((section) => {
      const partnerListItems = section.querySelectorAll(selectors.partnerListItems);
      const partnerListLinks = section.querySelectorAll(selectors.partnerListLinks);
      const partnerListImages = section.querySelectorAll(selectors.partnerListImages);
      const partnerListImagesArray = Array.from(partnerListImages);
      let zIndexCounter = partnerListImagesArray.length;

      // Handle animation for hover-capable devices only
      if (window.matchMedia('(hover: hover)').matches) {
        // Handle animation when section is visible
        if (partnerListItems.length > 0) {
          // Create intersection observer to watch when section reaches center of viewport
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && !entry.target.hasAttribute('data-animated')) {
                  entry.target.setAttribute('data-animated', 'true');

                  // Get the title, header, items, and image
                  const title = entry.target.querySelector(selectors.partnerListSectionTitle);
                  const header = entry.target.querySelector(selectors.partnerListHeader);
                  const imageInner = entry.target.querySelector(selectors.partnerListImageInner);

                  let delay = 0;

                  // Fade in title first if present
                  if (title) {
                    title.classList.add('fade-in');
                    delay += 100;
                  }

                  // Fade in header second
                  if (header) {
                    setTimeout(() => {
                      header.classList.add('fade-in');
                    }, delay);
                    delay += 100;
                  }

                  // Apply fade-in with staggered delay to items
                  partnerListItems.forEach((item, index) => {
                    setTimeout(
                      () => {
                        item.classList.add('fade-in');
                      },
                      delay + index * 100
                    );
                  });

                  // Calculate total delay for image (after all items)
                  const totalItemsDelay = delay + partnerListItems.length * 100;

                  // Fade in image last
                  if (imageInner) {
                    setTimeout(() => {
                      imageInner.classList.add('fade-in');
                    }, totalItemsDelay);
                  }

                  // Stop observing once animated
                  observer.unobserve(entry.target);
                }
              });
            },
            {
              rootMargin: '0px',
              threshold: 0.5, // Trigger when 50% of section is visible (center of page)
            }
          );

          // Observe the section
          observer.observe(section);
        }

        // Handle partner list links hover
        let rafId = null;

        partnerListLinks?.forEach((link) => {
          link.addEventListener('mouseenter', () => {
            if (link.classList.contains(classes.partnerLinkActive)) return;

            const handle = link.getAttribute('data-partner-handle');

            // Cancel pending animation frame
            if (rafId) cancelAnimationFrame(rafId);

            rafId = requestAnimationFrame(() => {
              const activeImage = partnerListImagesArray?.find((img) => img.dataset.partnerHandle === handle);

              // Remove active states
              partnerListLinks.forEach((l) => l.classList.remove(classes.partnerLinkActive));
              partnerListImages.forEach((img) => img.classList.remove(classes.partnerImageActive));

              // Set new active states
              link.classList.add(classes.partnerLinkActive);

              if (activeImage) {
                activeImage.classList.add(classes.partnerImageActive);
                activeImage.style.setProperty('--order', zIndexCounter++);
              }

              // Reset animation frame
              rafId = null;
            });
          });
        });
      }

      // Mobile-specific behavior
      if (window.matchMedia('(hover: none)').matches) {
        requestAnimationFrame(() => {
          // Get actual header height from CSS variable
          const headerHeightVar = getComputedStyle(document.body).getPropertyValue('--header-height').trim();
          const headerHeight = parseFloat(headerHeightVar) || 60;

          // Get actual image container height
          const imageContainer = section.querySelector(selectors.partnerListImageContainer);
          const imageHeight = imageContainer ? imageContainer.offsetHeight : 366;

          // Get actual Partner header height
          const partnerHeader = section.querySelector(selectors.partnerListHeader);
          const partnerHeaderHeight = partnerHeader ? partnerHeader.offsetHeight : 50;

          // Calculate total offset from the top of the page
          const totalOffset = headerHeight + imageHeight + partnerHeaderHeight;

          // Calculate bottom margin dynamically: viewport height minus detection line position
          // This creates a detection zone at totalOffset pixels from the top
          const bottomMargin = Math.floor(window.innerHeight - totalOffset);

          // Handle active image depending on partner name at the top of the list
          let currentActiveHandle = null;

          const updateActiveItem = () => {
            let closestItem = null;
            let closestDistance = Infinity;

            for (const item of partnerListItems) {
              const rect = item.getBoundingClientRect();

              // Skip if not visible
              if (rect.bottom <= 0 || rect.top >= window.innerHeight) continue;

              const distance = Math.abs(rect.top - totalOffset);

              // If we found an item very close to trigger point, use it immediately
              if (distance < 5) {
                closestItem = item;
                break;
              }

              if (distance < closestDistance) {
                closestDistance = distance;
                closestItem = item;
              }
            }

            if (!closestItem) return;

            const link = closestItem.querySelector(selectors.partnerListLinks);
            const handle = link?.getAttribute('data-partner-handle');

            // Only update if changed
            if (handle === currentActiveHandle) return;

            currentActiveHandle = handle;

            // Remove all active states
            partnerListLinks.forEach((l) => l.classList.remove(classes.partnerLinkActive));
            partnerListImages.forEach((img) => img.classList.remove(classes.partnerImageActive));

            // Set new active
            link.classList.add(classes.partnerLinkActive);

            const activeImage = partnerListImagesArray.find((img) => img.dataset.partnerHandle === handle);

            if (activeImage) {
              activeImage.classList.add(classes.partnerImageActive);
              activeImage.style.zIndex = zIndexCounter++;
            }
          };

          const observer = new IntersectionObserver(
            (entries) => {
              updateActiveItem();
            },
            {
              root: null,
              rootMargin: `0px 0px -${bottomMargin}px 0px`,
              threshold: [0, 0.5],
            }
          );

          partnerListItems.forEach((item) => {
            observer.observe(item);
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-share-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scrollShareSection = document.querySelector('[data-scroll-share-section]');
    if (!scrollShareSection) return;

    const scrollShare = scrollShareSection.querySelector('scroll-share');
    let resizeTimeout;
    let scrollRAF = null;
    let currentState = 'default';

    /**
     * Updates the --content-for-layout-height CSS variable on the scroll-share section
     * based on the measured height of .content-for-layout
     */
    const updateContentHeight = () => {
      const contentForLayout = document.querySelector('.content-for-layout');
      if (contentForLayout && scrollShareSection) {
        const height = contentForLayout.offsetHeight;
        scrollShareSection.style.setProperty('--content-for-layout-height', `${height}px`);
      }
    };

    /**
     * Checks the section's viewport position and toggles scroll-share
     * between default, fixed, and bottom-anchored states
     */
    const updatePosition = () => {
      if (!scrollShare) return;

      const contentOffset =
        parseFloat(getComputedStyle(scrollShareSection).getPropertyValue('--scroll-share-content-offset')) || 0;
      const headerHeight =
        (parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0) + contentOffset;

      const sectionRect = scrollShareSection.getBoundingClientRect();
      const scrollShareHeight = scrollShare.offsetHeight;

      const shouldFix = sectionRect.top <= headerHeight;
      const shouldBottom = sectionRect.bottom <= headerHeight + scrollShareHeight;

      let newState = 'default';
      if (shouldBottom) {
        newState = 'bottom';
      } else if (shouldFix) {
        newState = 'fixed';
      }

      if (newState === currentState) return;

      scrollShare.classList.remove('is-fixed', 'is-bottom');
      if (newState !== 'default') {
        scrollShare.classList.add(`is-${newState}`);
      }
      currentState = newState;
    };

    const handleScroll = () => {
      if (scrollRAF) return;
      scrollRAF = requestAnimationFrame(() => {
        updatePosition();
        scrollRAF = null;
      });
    };

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateContentHeight();
        updatePosition();
      }, 100);
    };

    const cleanup = () => {
      clearTimeout(resizeTimeout);
      if (scrollRAF) cancelAnimationFrame(scrollRAF);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const removedNode of mutation.removedNodes) {
          if (removedNode === scrollShareSection || removedNode.contains?.(scrollShareSection)) {
            cleanup();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll, { passive: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        updateContentHeight();
        updatePosition();
      });
    } else {
      updateContentHeight();
      updatePosition();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["work-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Trigger animation for the media element
    const sections = document.querySelectorAll('.work-intro-section');

    sections.forEach((section) => {
      const media = section.querySelector('.work-intro-section__media');
      if (!media) return;

      // Set media as animated so it only runs once
      const triggerAnimation = () => {
        if (media.hasAttribute('data-animated')) return;

        media.setAttribute('data-animated', 'true');
        media.classList.add('fade-in');

        // Stop both observers once animated
        scrollObserver.disconnect();
        visibilityObserver.disconnect();
      };

      // Trigger when 50% of media is visible
      const visibilityObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) triggerAnimation();
          });
        },
        {
          rootMargin: '0px',
          threshold: 0.5,
        }
      );

      // Also trigger when user scrolls to top of media (fallback for short screens)
      const scrollObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) triggerAnimation();
          });
        },
        {
          rootMargin: '0px 0px -100% 0px',
          threshold: 0,
        }
      );

      // Observe both, whichever triggers first wins
      visibilityObserver.observe(media);
      scrollObserver.observe(media);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["work-layout"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Initialize all work layout sections on the page
    function initWorkLayoutSections() {
      const allSections = document.querySelectorAll('.custom-grid-section[data-section-id]');

      allSections.forEach(function (gridSection) {
        const sectionId = gridSection.getAttribute('data-section-id');
        if (!sectionId) return;

        const cgridElement = gridSection.querySelector('.cgrid');
        if (!cgridElement) return;

        // Store active item per section
        let activeItem = null;

        // Helper function to get work list items for this specific section
        function getWorkListItems() {
          return cgridElement.querySelectorAll('.cgrid__item');
        }

        // List item interaction functionality
        function setActiveItem(item) {
          // Remove active class from previous item in this section
          if (activeItem && activeItem !== item) {
            activeItem.classList.remove('active');
            const prevVideo = activeItem.querySelector('video');
            if (prevVideo) {
              prevVideo.pause();
            }
            // Remove inline styles from previous item's media to allow CSS to control opacity
            const prevMedia = activeItem.querySelectorAll('.work-grid-item__image, .work-grid-item__video');
            prevMedia.forEach(function (media) {
              media.style.opacity = '';
              media.style.transition = '';
            });
          }

          // Set new active item
          activeItem = item;
          item.classList.add('active');

          // Remove inline styles from active item's media to allow CSS to control opacity
          const activeMedia = item.querySelectorAll('.work-grid-item__image, .work-grid-item__video');
          activeMedia.forEach(function (media) {
            media.style.opacity = '';
            media.style.transition = '';
          });

          // Play video if it exists
          const video = item.querySelector('video');
          if (video) {
            video.play().catch(function (e) {
              console.log('Video play failed:', e);
            });
          }
        }

        function handleItemInteraction(item) {
          setActiveItem(item);
        }

        // Touch detection thresholds
        const TOUCH_MOVE_THRESHOLD = 10; // pixels - movement beyond this is considered a scroll
        const TOUCH_TAP_MAX_DURATION = 500; // milliseconds - taps longer than this are ignored

        // Track touch state per touch identifier (handles multi-touch properly)
        // Map<touchIdentifier, { startY, startX, startTime, link }>
        const activeTouches = new Map();

        // Event handlers for list view interactions (scoped to this section)
        function handleMouseEnter(e) {
          const item = e.target.closest('.cgrid__item');
          if (item && cgridElement.contains(item) && cgridElement.classList.contains('list-view')) {
            handleItemInteraction(item);
          }
        }

        /**
         * Track touch start for scroll detection
         * Stores touch data keyed by touch identifier
         *
         * Note: .group-block__link is defined in blocks/_work-grid-item.liquid
         * It's an absolutely positioned overlay (inset: 0; z-index: 3) covering each work item
         */
        function handleTouchStart(e) {
          if (!cgridElement.classList.contains('list-view')) return;

          // .group-block__link - see blocks/_work-grid-item.liquid for definition
          const link = e.target.closest('.group-block__link');
          if (!link || !cgridElement.contains(link)) return;

          // Track each touch independently by its identifier
          for (const touch of e.changedTouches) {
            activeTouches.set(touch.identifier, {
              startY: touch.clientY,
              startX: touch.clientX,
              startTime: Date.now(),
              link: link,
            });
          }
        }

        /**
         * Handle touch end - intercept taps on links in list view
         * Uses scroll detection to avoid interfering with scrolling
         */
        function handleTouchEnd(e) {
          if (!cgridElement.classList.contains('list-view')) {
            // Clean up any tracked touches
            for (const touch of e.changedTouches) {
              activeTouches.delete(touch.identifier);
            }
            return;
          }

          for (const touch of e.changedTouches) {
            const touchData = activeTouches.get(touch.identifier);
            activeTouches.delete(touch.identifier);

            if (!touchData) continue;

            const link = e.target.closest('.group-block__link');
            if (link !== touchData.link) continue;

            const deltaY = Math.abs(touch.clientY - touchData.startY);
            const deltaX = Math.abs(touch.clientX - touchData.startX);
            const deltaTime = Date.now() - touchData.startTime;

            // If user moved significantly or held too long, it's a scroll/hold not a tap
            if (deltaY > TOUCH_MOVE_THRESHOLD || deltaX > TOUCH_MOVE_THRESHOLD || deltaTime > TOUCH_TAP_MAX_DURATION) {
              continue;
            }

            const item = link.closest('.cgrid__item');
            if (!item) continue;

            // If item is already active, allow the link to navigate
            if (item.classList.contains('active')) continue;

            // Item not active - prevent navigation and activate item instead
            e.preventDefault();
            handleItemInteraction(item);
          }
        }

        /**
         * Handle touch cancel - reset state when touch is interrupted
         * (e.g., system gesture, incoming call, etc.)
         */
        function handleTouchCancel(e) {
          for (const touch of e.changedTouches) {
            activeTouches.delete(touch.identifier);
          }
        }

        /**
         * Handle link clicks - for desktop and as fallback
         */
        function handleLinkClick(e) {
          if (!cgridElement.classList.contains('list-view')) return;

          const link = e.target.closest('.group-block__link');
          if (!link || !cgridElement.contains(link)) return;

          const item = link.closest('.cgrid__item');
          if (!item) return;

          // If item is already active, allow the link to navigate
          if (item.classList.contains('active')) {
            return;
          }

          // Item not active - prevent navigation and activate item instead
          e.preventDefault();
          e.stopPropagation();
          handleItemInteraction(item);
        }

        /**
         * Setup item interactions using event delegation (scoped to this section)
         * @returns {Function} Cleanup function to remove event listeners
         */
        function setupItemInteractions() {
          // Mouse hover for desktop - use capture phase for delegation
          gridSection.addEventListener('mouseenter', handleMouseEnter, true);

          // Touch events for iOS - touchend fires before click/navigation
          gridSection.addEventListener('touchstart', handleTouchStart, { passive: true });
          gridSection.addEventListener('touchend', handleTouchEnd, { passive: false });
          gridSection.addEventListener('touchcancel', handleTouchCancel, { passive: true });

          // Click handler as fallback and for non-touch devices
          gridSection.addEventListener('click', handleLinkClick, true);

          // Set first item as active if in list view on load
          if (cgridElement.classList.contains('list-view')) {
            const workListItems = getWorkListItems();
            if (workListItems.length > 0) {
              setActiveItem(workListItems[0]);
            }
          }

          // Return cleanup function for memory leak prevention
          return function cleanup() {
            gridSection.removeEventListener('mouseenter', handleMouseEnter, true);
            gridSection.removeEventListener('touchstart', handleTouchStart, { passive: true });
            gridSection.removeEventListener('touchend', handleTouchEnd, { passive: false });
            gridSection.removeEventListener('touchcancel', handleTouchCancel, { passive: true });
            gridSection.removeEventListener('click', handleLinkClick, true);
            activeTouches.clear();
          };
        }

        // Set up event delegation for this section
        const cleanupInteractions = setupItemInteractions();

        // View toggle functionality (only if toggle mode is enabled)
        const viewMode = gridSection.getAttribute('data-view-mode');
        let cleanupToggle = null;

        if (viewMode === 'toggle') {
          const viewToggleContainer = document.querySelector('.view-toggle[data-section-id="' + sectionId + '"]');

          /**
           * Handle view toggle between grid and list
           * @param {string} view - 'grid' or 'list'
           */
          function toggleViewForSection(view) {
            const gridViewBtn = document.getElementById('grid-view-btn-' + sectionId);
            const listViewBtn = document.getElementById('list-view-btn-' + sectionId);

            if (!gridViewBtn || !listViewBtn) return;

            if (view === 'grid') {
              gridViewBtn.classList.add('active');
              listViewBtn.classList.remove('active');

              // Clear active item when switching to grid
              if (activeItem) {
                activeItem.classList.remove('active');
                const video = activeItem.querySelector('video');
                if (video) {
                  video.pause();
                }
                activeItem = null;
              }

              // Fade out transition
              gridSection.style.opacity = '0';
              setTimeout(function () {
                // Remove list-view class from cgrid
                cgridElement.classList.remove('list-view');

                // Restore images and videos to visible state for grid view
                const allImages = cgridElement.querySelectorAll('.work-grid-item__image, .work-grid-item__video');
                allImages.forEach(function (media) {
                  media.style.transition = 'none';
                  media.style.opacity = '1';
                  // Restore transition after a brief moment
                  setTimeout(function () {
                    media.style.transition = '';
                  }, 10);
                });

                // Play all videos when switching to grid view
                const allVideos = cgridElement.querySelectorAll('video');
                allVideos.forEach(function (video) {
                  video.play().catch(function (e) {
                    console.log('Video play failed:', e);
                  });
                });

                // Fade in transition
                setTimeout(function () {
                  gridSection.style.opacity = '1';
                }, 10);
              }, 300);
            } else {
              listViewBtn.classList.add('active');
              gridViewBtn.classList.remove('active');

              // Immediately hide all images and videos before transition
              const allImages = cgridElement.querySelectorAll('.work-grid-item__image, .work-grid-item__video');
              const workListItems = getWorkListItems();
              const firstItem = workListItems.length > 0 ? workListItems[0] : null;

              allImages.forEach(function (media) {
                // Keep first item's media visible, hide all others
                const mediaItem = media.closest('.cgrid__item');
                if (mediaItem !== firstItem) {
                  media.style.transition = 'none';
                  media.style.opacity = '0';
                }
              });

              // Fade out transition
              gridSection.style.opacity = '0';
              setTimeout(function () {
                // Add list-view class to cgrid
                cgridElement.classList.add('list-view');

                // Restore transitions for all images and videos
                allImages.forEach(function (media) {
                  media.style.transition = '';
                });

                // Set first item as active when switching to list view
                if (firstItem) {
                  setActiveItem(firstItem);
                }

                // Fade in transition
                setTimeout(function () {
                  gridSection.style.opacity = '1';
                }, 10);
              }, 600);
            }
          }

          /**
           * Handle click on toggle buttons using event delegation
           */
          function handleToggleClick(e) {
            const button = e.target.closest('[data-action="toggle-view"]');
            if (!button) return;

            const view = button.dataset.view;
            if (view) {
              toggleViewForSection(view);
            }
          }

          // Set up event delegation for toggle buttons
          if (viewToggleContainer) {
            viewToggleContainer.addEventListener('click', handleToggleClick);

            // Return cleanup function
            cleanupToggle = function () {
              viewToggleContainer.removeEventListener('click', handleToggleClick);
            };
          }
        }

        // Update section unload handler to include toggle cleanup
        document.addEventListener('shopify:section:unload', function handleSectionUnload(e) {
          if (e.detail.sectionId === sectionId) {
            cleanupInteractions();
            if (cleanupToggle) cleanupToggle();
            document.removeEventListener('shopify:section:unload', handleSectionUnload);
          }
        });
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWorkLayoutSections);
    } else {
      initWorkLayoutSections();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
